import { fetchData } from "@axios/axios-client";

export const getRestaurantApi = ({
  restaurantId,
}: {
  restaurantId: string;
}) => {
  return fetchData({}, `dining/restaurants/${restaurantId}`, "GET", true);
};

export const getRestaurantsApi = () => {
  return fetchData({}, `dining/restaurants`, "GET", true);
};

export const createRestaurantApi = ({ data }: { data: any }) => {
  return fetchData(data, `dining/restaurants`, "POST", false, true);
};

export const bulkUpdateRestaurantsApi = ({ data }: { data: any }) => {
  return fetchData(data, `dining/restaurants`, "PUT");
};

export const updateRestaurantApi = ({
  restaurantId,
  data,
  icon,
  banner,
}: {
  restaurantId: string;
  data: any;
  icon?: File;
  banner?: File;
}) => {
  return fetchData(
    { icon, banner, payload: JSON.stringify(data) },
    `dining/restaurants/${restaurantId}`,
    "PATCH",
    false,
    true
  );
};

export const deleteRestaurantApi = ({
  restaurantId,
}: {
  restaurantId: string;
}) => {
  return fetchData({}, `dining/restaurants/${restaurantId}`, "DELETE");
};

// Category

export const getCategoriesApi = ({
  restaurantId,
}: {
  restaurantId: string;
}) => {
  return fetchData({}, `dining/restaurants/${restaurantId}/categories`, "GET");
};

export const createCategoryApi = ({
  data,
  restaurantId,
}: {
  data: any;
  restaurantId: string;
}) => {
  return fetchData(
    data,
    `dining/restaurants/${restaurantId}/categories`,
    "POST"
  );
};

export const updateCategoryApi = ({
  data,
  restaurantId,
  categoryId,
}: {
  data: any;
  restaurantId: string;
  categoryId: string;
}) => {
  return fetchData(
    data,
    `dining/restaurants/${restaurantId}/categories/${categoryId}`,
    "PATCH"
  );
};

export const bulkUpdateCategoriesApi = ({
  data,
  restaurantId,
}: {
  data: any;
  restaurantId: string;
}) => {
  return fetchData(
    data,
    `dining/restaurants/${restaurantId}/categories`,
    "PUT"
  );
};

export const deleteCategoryApi = ({
  restaurantId,
  categoryId,
}: {
  restaurantId: string;
  categoryId: string;
}) => {
  return fetchData(
    {},
    `dining/restaurants/${restaurantId}/categories/${categoryId}`,
    "DELETE"
  );
};

// Product
export const getProductsApi = ({ restaurantId }: { restaurantId: string }) => {
  return fetchData({}, `dining/restaurants/${restaurantId}/products`, "GET");
};

export const createProductApi = ({
  data,
  restaurantId,
}: {
  data: any;
  restaurantId: string;
}) => {
  return fetchData(
    data,
    `dining/restaurants/${restaurantId}/products`,
    "POST",
    false,
    true
  );
};

export const updateProductApi = ({
  data,
  restaurantId,
  productId,
}: {
  data: any;
  restaurantId: string;
  productId: string;
}) => {
  return fetchData(
    data,
    `dining/restaurants/${restaurantId}/products/${productId}`,
    "PATCH",
    false,
    true
  );
};

export const bulkUpdateProductsApi = ({
  data,
  restaurantId,
}: {
  data: any;
  restaurantId: string;
}) => {
  return fetchData(data, `dining/restaurants/${restaurantId}/products`, "PUT");
};

export const deleteProductApi = ({
  restaurantId,
  productId,
}: {
  restaurantId: string;
  productId: string;
}) => {
  return fetchData(
    {},
    `dining/restaurants/${restaurantId}/products/${productId}`,
    "DELETE"
  );
};

// Variants
export const getVariantsApi = ({ restaurantId }: { restaurantId: string }) => {
  return fetchData({}, `dining/restaurants/${restaurantId}/variants`, "GET");
};

export const createVariantApi = ({
  data,
  restaurantId,
}: {
  data: any;
  restaurantId: string;
}) => {
  return fetchData(data, `dining/restaurants/${restaurantId}/variants`, "POST");
};

export const bulkUpdateVariantsApi = ({
  data,
  restaurantId,
}: {
  data: any;
  restaurantId: string;
}) => {
  return fetchData(data, `dining/restaurants/${restaurantId}/variants`, "PUT");
};

export const updateVariantApi = ({
  data,
  restaurantId,
  variantId,
}: {
  data: any;
  restaurantId: string;
  variantId: string;
}) => {
  return fetchData(
    data,
    `dining/restaurants/${restaurantId}/variants/${variantId}`,
    "PATCH"
  );
};

export const deleteVariantApi = ({
  restaurantId,
  variantId,
}: {
  restaurantId: string;
  variantId: string;
}) => {
  return fetchData(
    {},
    `dining/restaurants/${restaurantId}/variants/${variantId}`,
    "DELETE"
  );
};

// Variants Options
export const getVariantsOptionsApi = ({
  restaurantId,
}: {
  restaurantId: string;
}) => {
  return fetchData(
    {},
    `dining/restaurants/${restaurantId}/variants/options`,
    "GET"
  );
};

export const createVariantOptionApi = ({
  data,
  restaurantId,
  variantId,
}: {
  data: any;
  restaurantId: string;
  variantId: string;
}) => {
  return fetchData(
    data,
    `dining/restaurants/${restaurantId}/variants/${variantId}/options`,
    "POST"
  );
};

export const bulkUpdateVariantOptionsApi = ({
  data,
  restaurantId,
}: {
  data: any;
  restaurantId: string;
}) => {
  return fetchData(
    data,
    `dining/restaurants/${restaurantId}/variants/options`,
    "PUT"
  );
};

export const deleteVariantOptionApi = ({
  restaurantId,
  variantOptionId,
}: {
  restaurantId: string;
  variantOptionId: string;
}) => {
  return fetchData(
    {},
    `dining/restaurants/${restaurantId}/variants/options/${variantOptionId}`,
    "DELETE"
  );
};
